import { defineStore } from 'pinia';
import GlobalRequest from '@/api/global-request';
// getFormattedFontArray;
import {  getFormattedTreeTableArray, getFlattenArray } from '@/helpers/json-formatter';
import { showToast } from '@/helpers/toast-handler';
import { ContainerTypes } from '../../enums';
// const ASSESSMENT_REPORT_URL = 'v2/assessment/report';
const RESULT_BLOCK_URL = 'v2/result/block';
const parentTypes = [ContainerTypes.COVER_1, ContainerTypes.COVER_2, ContainerTypes.COVER_3, ContainerTypes.COVER_4, ContainerTypes.MAIN, ContainerTypes.CONTAINER];

export const useAssessmentResultStore = defineStore('assessmentResult', {
    state: () => ({
        fonts: [],
        resultTemplate: {},
        resultTemplates: [],
        parentTemplates: [],
    }),
    actions: {
        async getAllFonts() {
            try {
                // const response = await GlobalRequest.getRequest(ASSESSMENT_REPORT_URL + '/fonts');
                // this.fonts = getFormattedFontArray(response.data);
                // as per IG-359:- for now only use these 'sans/OpenSans-Bold', 'sans/OpenSans-Italic','sans/OpenSans-Regular';
                this.fonts = [
                    { name: 'Regular', value: 'sans/OpenSans-Regular' },
                    { name: 'Bold', value: 'sans/OpenSans-Bold' },
                    { name: 'Italic', value: 'sans/OpenSans-Italic' },
                ];
                return this.fonts;
            } catch (error) {
                throw new Error('Failed to fetch all fonts');
            }
        },

        async addResultTemplate(block_id, resultTemplateBody) {
            try {
                const response = await GlobalRequest.postRequest(RESULT_BLOCK_URL + '/' + block_id + '/template', resultTemplateBody);
                this.resultTemplate = response.data;
                await this.getAllTemplatesLinkedToBlock(block_id, resultTemplateBody.company_id);
                if (response.message == 'Ok') showToast(response, 'Element added to the module');
                return this.resultTemplate;
            } catch (error) {
                throw new Error('Failed to add result template');
            }
        },

        async deleteResultTemplate(block_id, template_id, company_id) {
            try {
                const response = await GlobalRequest.deleteRequest(RESULT_BLOCK_URL + '/' + block_id + '/template/' + template_id, {
                    params: {
                        company_id,
                    },
                });
                if (response.message == 'Ok') {
                    // reload the result templates
                    await this.getAllTemplatesLinkedToBlock(block_id, company_id);
                    showToast(response, 'Element deleted from block');
                }
            } catch (error) {
                throw new Error('Failed to delete result template');
            }
        },

        async getAllTemplatesLinkedToBlock(block_id, company_id) {
            try {
                const response = await GlobalRequest.getRequest(RESULT_BLOCK_URL + '/' + block_id + '/template', {
                    params: {
                        company_id,
                    },
                });
                this.resultTemplates = response.data;
                this.getParentTemplates(block_id, company_id);
                return this.resultTemplates;
            } catch (error) {
                throw new Error('Failed to add result template');
            }
        },

        // Parent templates are the result templates with no Containers compatibility
        // It removes the elements that doesnt have container compatibility
        async getParentTemplates(block_id, company_id) {
            const response = await GlobalRequest.getRequest(RESULT_BLOCK_URL + '/' + block_id + '/template', {
                params: {
                    company_id,
                },
            });
            // create an array of parent elements from the resultTemplates by filtering out the containers types only
            this.parentTemplates = getFlattenArray(response.data)
                ?.filter((element) => parentTypes.includes(element.type))
                ?.map((obj) => {
                    return {
                        id: obj.id,
                        value: obj.id,
                        name: 'Id:' + obj.id + '|| Name: ' + obj.name + ' || Type:' + obj.type,
                    };
                });
            return this.parentTemplates;
        },
    },
    getters: {
        getResultTemplates() {
            return getFormattedTreeTableArray(this.resultTemplates);
        },
    },
    persist: () => ({
        // enabled: true,
    }),
});
